<template>
  <div class="books-container">
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row hidden-row"></div>
        <div class="row">
          <div class="col-12 my-5">
            <h5>
              <unicon
                :name="'heart'"
                :fill="secCol"
                style="margin-right: 8px;"
              />
              <span>Libros Favoritos</span>
            </h5>
          </div>
        </div>

        <div class="row" v-if="books.length">
          <template v-for="(book, i) in books">
            <BookCard
              :key="i"
              :data="book"
              @openBookModal="openBookModal(book)"
            />
          </template>
        </div>
        <div class="row" v-else>
          <div class="col-12 text-center">
            <Spinner v-if="showSpinner" />
            <span class="text-gray" v-if="!showSpinner && !books.length">
              No hay favoritos para mostrar
            </span>
          </div>
        </div>

        <div class="row">
          <FooterComponent />
        </div>

        <BookModal
          :data="modalData"
          v-if="showModal.bookModal"
          @close="showModal.bookModal = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FooterComponent from "@/components/Footer";
import BookCard from "@/components/Books/BookCard";
import BookModal from "@/components/Books/BookModal";
import Spinner from "@/components/Spinner";

export default {
  name: "Books",
  components: {
    FooterComponent,
    BookCard,
    BookModal,
    Spinner,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      showSpinner: false,
      showModal: {
        bookModal: false,
      },
      books: [],
      currentPage: 0,
      totalPages: null,
      sizeList: 10,
      modalData: null,
      bookTitle: "",
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData"]),
  },
  methods: {
    openBookModal(data) {
      this.modalData = data;
      this.showModal.bookModal = true;
    },
    async getBooksList() {
      let apiUrl = `${this.dataUrl}/bookUserFavorite/getFavoriteBooksByUser?userId=${this.teacherData.id}`;
      this.books = [];
      this.showSpinner = true;

      try {
        let { data } = await this.axios.get(apiUrl);
        this.books = data.content;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.showSpinner = false;
      }
    },
  },
  mounted() {
    this.getBooksList();
  },
};
</script>

<style lang="scss" scoped>
.books-container {
  min-height: calc(100vh - 304px);
}

.subtitle {
  font-size: 14px;
}
</style>
